import { useContext, useEffect, useState } from "react"
import ApiContext from "src/provider/API/call-service"
import UserContext from "src/provider/state-manager/userProvider"
import { AbsoluteContainer, AppSpan, AppText, CustomContainer, FixedContainer, FlexRow, GridContainer, ScreenTitle } from "src/style"
//import {ReactComponent as NotifIcon} from 'src/assets/img/notif-icon.svg'
import NotifIcon from 'src/assets/svg/notification-icon'
import {ReactComponent as NoDataIcon} from 'src/assets/img/no-data-icon.svg'
import { INotifications } from "src/model"
import helpers from "src/utils/helpers"
import { getCharacterToDispay } from "src/utils/utility"

export const NotificationLayout: React.FC<any> = ({isD3}) => {
    const {API} = useContext(ApiContext)
    const {user: {notifications, userInfo}} = useContext(UserContext)
    const [allNotifications, setAllNotifications] = useState<Array<INotifications>|null>(null)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        //console.log({notif: notifications})
        if (notifications) setAllNotifications(helpers.formatNotification(notifications))
    }, [notifications])

    useEffect(() => {
        if (userInfo?.profileID) handleFetchNotification()
    }, [userInfo?.profileID])

    const handleFetchNotification = async () => {
        setIsLoading(true)
        await API.getNotifications(false)
        setIsLoading(false)
    } 

    return (
        <CustomContainer>
            { (isLoading) &&
                <AbsoluteContainer top='0' left='0' zIndex='3' width='100' sizeUnit='%' height="full" bgColor='rgba(255, 255, 255, 0.5)'>
                    <GridContainer height='80' hUnit="vh" >
                        <AppSpan textSize='4' color='#0D968F' className='fa fa-spinner fa-spin' />
                    </GridContainer>
                </AbsoluteContainer>
            }
            { !isD3 && <ScreenTitle textSize="2.2" fontWeight="700">Notifications</ScreenTitle>}
            { !!allNotifications?.length ?
                <CustomContainer topMargin={!isD3 ? "2.5" : '0'} height="80" hUnit="vh" className="overflow-y-container">
                    {
                        allNotifications?.map((item, index) => {
                            return (
                                    <CustomContainer key={index} topMargin="2">
                                        <AppText>{item?.date}</AppText>
                                        {
                                            item.info?.map((data: any, innerIndex: number) => {
                                                let dateTime = helpers.splitDateTime(data?.dateCreated)
                                                return (
                                                    <GridContainer 
                                                        minHeight="6.4" borderColor="#EAECF0" radius="0.8"
                                                        padding="1" topPadding="1" bottomPadding="1" 
                                                        topMargin="2" key={innerIndex}
                                                    >
                                                        <FlexRow gap="2" justifyContent="space-between" alignItems="flex-start">
                                                            <FlexRow width="auto" sizeUnit="" gap="1" alignItems="center">
                                                                <NotifIcon 
                                                                    className="icon-component" 
                                                                    style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                                                                />
                                                                <CustomContainer width="auto" sizeUnit="">
                                                                    <AppSpan textSize="1.5" fontWeight="600">{data?.title}</AppSpan>
                                                                    <AppText textSize="1.3" color="#A5A5A5">{getCharacterToDispay(data?.message, 57)}</AppText>
                                                                </CustomContainer>
                                                            </FlexRow>
                                                            <AppSpan textSize="1.3" color="#D0C7C7">{dateTime.slashedDate} {dateTime.completeTime}</AppSpan>
                                                        </FlexRow>
                                                    </GridContainer>
                                                )
                                            })
                                        }
                                    </CustomContainer>
                                )
                        })
                    }
                </CustomContainer>
                :
                <GridContainer topMargin="18">
                    <CustomContainer width="auto" sizeUnit="">
                        <NoDataIcon className="icon-component" />
                        <AppText textSize="1.6" fontWeight="600" color="#101828" align="center" topMargin="1.5">
                            No Notification
                        </AppText>
                    </CustomContainer>
                </GridContainer>
            }
        </CustomContainer>
    )
}